import { FrontendCompanyWithAdditionalInfomation } from "node-library/dist/portal";

//ADMIN ACTION TO OVERWRITE FRONTEND CACHED COMPANY INFO
export function overwriteFrontendCompanyInfo(
	info: FrontendCompanyWithAdditionalInfomation,
	setCompany: React.Dispatch<
		React.SetStateAction<FrontendCompanyWithAdditionalInfomation | undefined>
	>,
): void {
	localStorage.setItem(
		"billionspectra_lims_companyAdditionalInfo",
		JSON.stringify(info),
	);
	setCompany(info);
}
